export const START_DATE_ICON = 'start-date';
export const DUE_DATE_ICON = 'due-date';
export const OVERDUE_ICON = 'overdue';
export const DATE_FORMAT_TOOLTIP = 'D MMM YYYY';
export const DATE_FORMAT_INDICATOR = 'D MMM';
export const OVERDUE_MODIFIER = 'overdue';
